import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NotificationService } from 'ui-components/services/notification-service';
import { messages } from './messages';

const NOTO_TYPE_ERROR = 'error';

const NOTIFICATION_DURATION_IN_MS = 5000;

const showBulkNotification = (notificationType, isProgress, titleTranslation, contentTranslation) => {
  const notoProps = {
    notificationType,
    title: <FormattedMessage {...titleTranslation} />,
    content: <FormattedMessage {...contentTranslation} />,
    progress: isProgress,
    dontHide: isProgress,
    duration: isProgress ? undefined : NOTIFICATION_DURATION_IN_MS,
  };
  return NotificationService.showNotification({ ...notoProps });
};

class BulkPurchaseNotificationServiceClass {
  showGenericHttpNotification() {
    return showBulkNotification(NOTO_TYPE_ERROR, false, messages.errorTitle, messages.genericHttpErrorContent);
  }

  removeNotification(notificationId) {
    NotificationService.removeNotification(notificationId);
  }
}

export const BulkPurchaseNotificationService = new BulkPurchaseNotificationServiceClass();
